module.exports = __webpack_public_path__ + "assets/img/2.0e919d4b.png";